//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  data: function () {
    return {
      scenarioId: ''
    }
  },
  computed: {
    ...mapState({
      scenarioDialog: state => state.preferences.global.scenarioDialog,
      scenarios: state => state.preferences.global.scenarios
    })
  },
  methods: {
    onOK: function () {
      this.closeDialog();
      if (this.scenarioId) this.$emit('update-scenario-id', this.scenarioId);
    },
    closeDialog: function () {
      this.$store.commit("preferences/updateScenarioDialog", false);
    }
  },
  watch: {
    scenarios: function () {
      this.scenarioId = this.scenarios[0]
    }
  }
}
